import React from 'react';
import './index.scss';
import classNames from 'classnames';

const CopilotAnswerLoading = (props: any) => {
  const { className } = props;
  return (
    <section className={classNames('dba-copilot-answer-loading', className)}>
      <div className="dba-load-long"></div>
      <div className="dba-load-mid"></div>
      <div className="dba-load-short"></div>
    </section>
  );
};
export default CopilotAnswerLoading;
